module.exports = require("./lg-UG");